import { deleteRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function deleteGlobalAddressRequest(idToDelete) {
	let url = globalAddresses.getByIdPath(idToDelete);
	let response = await deleteRequest(url);

	return response;
}
